import { Dog } from "lucide-react";
import { getSubscriberStatusColor } from "../../../../../services/functions";
import { displayValue, formatDate } from "../helpers";
import { Attribute, EmptySection } from "./SectionPrimitives";

export function SubscriptionsSection({ subscriptions }) {
  if (!subscriptions.length) {
    return <EmptySection>Nenhuma assinatura encontrada.</EmptySection>
  }


  return (
    <div className="pt-3 pb-6 gap-3 flex flex-wrap">
      {subscriptions.map((subscription, index) => (
        <article
          className="rounded-lg border border-gray-200 bg-background min-w-fit flex-1"
          key={subscription.id || index}
        >
          <div className="mb-4 flex flex-wrap items-start justify-between gap-2 border-b border-gray-100 p-4">
            <h3 className="font-semibold items-center text-base text-gray-800 flex gap-2">
              <Dog size={18} />{displayValue(subscription.petName)}
            </h3>
            <p className="flex items-center text-base gap-2">
              <span className="font-semibold">Plano:</span>{displayValue(subscription.planName || subscription.planType)}
            </p>
            <span style={{ background: getSubscriberStatusColor(subscription.status) }} className="rounded-full px-3 py-1 text-xs font-semibold text-white">
              {displayValue(subscription.status)}
            </span>
          </div>

          <dl className="grid grid-cols-2 gap-4 md:grid-cols-3 px-4 pb-4">
            <div>
              <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">Início</span>
              <p className="flex gap-1 text-sm text-gray-800">{formatDate(subscription.startedAt)}</p>
            </div>
            <div>
              <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">Liberado até</span>
              <p className="flex gap-1 text-sm text-gray-800">{formatDate(subscription.validAt)}</p>
            </div>
            <div>
              <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">Próx. Cobrança</span>
              <p className="flex gap-1 text-sm text-gray-800">{formatDate(subscription.nextBillingAt)}</p>
            </div>
            <div>
              <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">Cancelada em</span>
              <p className="flex gap-1 text-sm text-gray-800">
                {subscription.canceledAt ? formatDate(subscription.canceledAt) : "-"}
              </p>
            </div>
            <div>
              <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">Disponível</span>
              <p className="flex gap-1 text-sm text-gray-800">
                <span>{displayValue(subscription.quantityAvailable)}</span>
                <span>{subscription.quantityAvailable > 1 ? "Banhos" : "banho"}</span>
              </p>
            </div>

          </dl>
        </article>
      ))}
    </div>
  );
}
